import type {
  AdminCategory,
  AdminGame,
  AnalyticsOverview,
  AppSettings,
  CatalogRelease,
  CatalogStatus,
  Dashboard,
  GameAnalytics,
  IntegrationStatus,
  MediaAsset,
  OnlineNow,
  Paginated,
} from "@lucky-try/contracts";
import { queryOptions } from "@tanstack/react-query";
import { api } from "./api";

export const dashboardQuery = queryOptions({
  queryKey: ["dashboard"],
  queryFn: () => api<Dashboard>("/admin/dashboard"),
  staleTime: 30_000,
});

export const categoriesQuery = queryOptions({
  queryKey: ["categories"],
  queryFn: () => api<{ items: AdminCategory[] }>("/admin/categories"),
  staleTime: 60_000,
});

export const gameQuery = (id: number) =>
  queryOptions({
    queryKey: ["game", id],
    queryFn: () => api<AdminGame>(`/admin/games/${id}`),
  });

export const mediaQuery = (query: { page: number; q?: string; storage?: "r2" | "external" }) =>
  queryOptions({
    queryKey: ["media", query],
    queryFn: () =>
      api<Paginated<MediaAsset>>("/admin/media", { query: { ...query, pageSize: 60 } }),
  });

export const catalogStatusQuery = queryOptions({
  queryKey: ["catalog-status"],
  queryFn: () => api<CatalogStatus>("/admin/catalog/status"),
});

export const catalogReleasesQuery = queryOptions({
  queryKey: ["catalog-releases"],
  queryFn: () => api<{ items: CatalogRelease[] }>("/admin/catalog/releases"),
});

export const settingsQuery = queryOptions({
  queryKey: ["settings"],
  queryFn: () => api<AppSettings>("/admin/settings"),
});

export const integrationsQuery = queryOptions({
  queryKey: ["integrations"],
  queryFn: () => api<IntegrationStatus>("/admin/integrations"),
});

export const analyticsOverviewQuery = (range: { from: string; to: string }) =>
  queryOptions({
    queryKey: ["analytics", "overview", range],
    queryFn: () => api<AnalyticsOverview>("/admin/analytics/overview", { query: range }),
  });

export const onlineNowQuery = queryOptions({
  queryKey: ["analytics", "online"],
  queryFn: () => api<OnlineNow>("/admin/analytics/online"),
  refetchInterval: 30_000,
  staleTime: 0,
});

export const gameAnalyticsQuery = (id: number, range: { from: string; to: string }) =>
  queryOptions({
    queryKey: ["analytics", "game", id, range],
    queryFn: () => api<GameAnalytics>(`/admin/analytics/games/${id}`, { query: range }),
  });
